import { Button, makeStyles, withStyles } from '@material-ui/core';
import { useSetRecoilState } from 'recoil';
import { csAdjustVerticalZoomWithRouteSelector } from '../../store/CsAdjustVerticalZoomWithRouteState';

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: 132
  }
}));

const CustomButton = withStyles({
  sizeSmall: {
    fontSize: 12,
    height: 21
  },
  outlined: {
    color: 'rgba(255, 100, 0, 0.9)',
    border: '1px solid rgba(255, 100, 0, 0.9)'
  },
  root: {
    '&:hover': {
      color: 'rgba(255, 100, 0, 1)',
      border: '1px solid rgba(255, 100, 0, 1)'
    }
  },
  label: {
    position: 'relative',
    top: 1
  }
})(Button);

function FLHeightControlPanel() {
  const setCsAdjustVerticalZoomWithRoute = useSetRecoilState(csAdjustVerticalZoomWithRouteSelector);
  const classes = useStyles();

  function buttonClickHandler(adjust) {
    setCsAdjustVerticalZoomWithRoute(prev => {
      return {...prev, ...{adjust: adjust, update: true}}
    });
  }

  return (
    <div id="cs-fl-height-zoom" className={classes.container}>
      <CustomButton size='small' variant='outlined' onClick={() => buttonClickHandler(true)}>Low</CustomButton>
      <CustomButton size='small' variant='outlined' onClick={() => buttonClickHandler(false)}>High</CustomButton>
    </div>
  );
}

export default FLHeightControlPanel;
